module.exports = __webpack_public_path__ + "static/fast-button-accent-bb6404e426989aa46b216c4e5315643f.png";